import { OfferRoundel } from './offer-roundel'

export default OfferRoundel
